module.exports = __webpack_public_path__ + "static/media/loading.5fe4039b.gif";